import { KYC_STATUS } from "@/constant/Constant";
import SumsubKyc from "@/pages/kyc/Sumsub";
import KYCPreForm from "@/pages/user/components/KYCPreForm";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

function GuideKYC({onComplete}) {
  const { t } = useTranslation();
  const { user } = useSelector(state => state.user);

  const [inited, setInited] = useState(false);
  const [showPreForm, setShowPreForm] = useState(false);

  useEffect(() => {
    if (user) {
      if (!inited) {
        setInited(true);
      }
      _checkKycStatus();
    }
  }, [user]);

  const _checkKycStatus = () => {
    if (user.hasSubmitKycPreInfo != 1) {
      setShowPreForm(true);
    }
  }

  const _keyPreFormEntry = () => {
    if (user.kycStatus == KYC_STATUS.KYC_STATUS_APPROVED || user.kycStatus == KYC_STATUS.KYC_STATUS_SUBMITTED) {
      return null;
    }

    return <div onClick={() => setShowPreForm(true)}>
      {t('personal_info_review')}
    </div>
  }

  if (!inited) return <>Checking KYC Status...</>;
  // if (user.kycStatus == KYC_STATUS.KYC_STATUS_APPROVED) return <>KYC has approved</>; 

  if (showPreForm) {
    return <KYCPreForm onSuccess={() => setShowPreForm(false)} />
  }

  return (
    <>
      <SumsubKyc onComplete={onComplete} />

      {_keyPreFormEntry()}
    </>
  )
}

export default GuideKYC
